"use client"
// import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row, Input, Form, FormFeedback, Button, Spinner, Table, CardTitle, FormGroup } from "reactstrap";
import { Label, InputGroup, Card, CardBody, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FieldArray, FormikProvider } from "formik";
import fn_helper from "helpers/fn_helper";
import PopupAttachment from "components/Input/attachment/PopupAttachment";

const CardPiecePerformance = ({
    pageView,
    validation,
    cardNumber,
    contentCardShow,
    runningNo = 0
}) => {
    let cardRef = useRef(null);

    useEffect(() => {
        if(cardRef !== null) {
            cardRef.current.checked = contentCardShow;
        }
    }, [cardRef])

    const checkValue = validation?.values[`contentCard${cardNumber}Show`] ?? false

    return (
        <>
            <Col md={6}>
                <Card color="light">
                    <CardBody className="p-2">
                        <CardTitle className="m-0">
                            <FormGroup switch>
                                <Input
                                    innerRef={cardRef}
                                    id={`contentCard${cardNumber}Show`}
                                    className="align-middle"
                                    type="switch"
                                    role="switch"
                                    name={`contentCard${cardNumber}Show`}
                                    checked={checkValue}
                                    onClick={e => {
                                        const oldValue = checkValue
                                        validation.setFieldValue(`contentCard${cardNumber}Show`, !oldValue)
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched[`contentCard${cardNumber}Show`] &&
                                                validation.errors[`contentCard${cardNumber}Show`]
                                                ? true
                                                : false
                                    }
                                    disabled={pageView === "view"}
                                />
                                <Label className="align-middle m-0" htmlFor={`contentCard${cardNumber}Show`}>
                                    <span className="align-middle">Card {runningNo} {validation.values[`contentCard${cardNumber}Show`]}</span>
                                    <i className="bx bxs-grid drag-handle align-middle" style={{ cursor: "grab" }} />
                                </Label>
                            </FormGroup>
                        </CardTitle>
                    </CardBody>
                    <CardBody className="p-1">
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item p-2">
                                <Col md={12}>
                                    <PopupAttachment
                                        typeDetail="single"
                                        typeUpload="ImageMap"
                                        upload="Image"
                                        prefixName={`section-performance-card${cardNumber}`}
                                        label="Image"
                                        required={false}
                                        description="description"
                                        widthSize={56}
                                        heightSize={56}
                                        value={validation.values[`card${cardNumber}Image`]}
                                        onChange={(value = {}, index) => {
                                            console.log("🚀 onChange ~ value:", value)
                                            console.log("🚀 onChange ~ index:", index)
                                            validation.setFieldValue(`card${cardNumber}Image`, value)
                                        }}
                                        onRemove={(index) => {
                                            console.log("🚀 onChange ~ index:", index)
                                            validation.setFieldValue(`card${cardNumber}Image`, {})
                                        }}
                                    />
                                    {validation.touched[`card${cardNumber}Image`] && validation.errors[`card${cardNumber}Image`] && (
                                        <div type="invalid" className="invalid-feedback d-block">
                                            {validation.errors[`card${cardNumber}Image`]}
                                        </div>
                                    )}
                                </Col>
                            </li>
                            <li className="list-group-item p-2">
                                <label
                                    htmlFor={`contentCard${cardNumber}Detail`}
                                    className="col-md-12 col-form-label"
                                >
                                    Detail
                                </label>
                                <div className="col-md-12">
                                    <Input
                                        id={`contentCard${cardNumber}Detail`}
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name={`contentCard${cardNumber}Detail`}
                                        onChange={e => {
                                            validation.setFieldValue(
                                                `contentCard${cardNumber}Detail`,
                                                e.target.value
                                            )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`contentCard${cardNumber}Detail`]}
                                        invalid={
                                            validation.touched[`contentCard${cardNumber}Detail`] &&
                                                validation.errors[`contentCard${cardNumber}Detail`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                    />
                                    {validation.touched[`contentCard${cardNumber}Detail`] &&
                                        validation.errors[`contentCard${cardNumber}Detail`] && (
                                            <FormFeedback type="invalid">
                                                {validation.errors[`contentCard${cardNumber}Detail`]}
                                            </FormFeedback>
                                        )}
                                </div>
                            </li>
                            <li className="list-group-item p-2">
                                <label
                                    htmlFor="contentCard1Number"
                                    className="col-md-12 col-form-label"
                                >
                                    Number
                                </label>
                                <div className="col-md-12">
                                    <Input
                                        id={`contentCard${cardNumber}Number`}
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name={`contentCard${cardNumber}Number`}
                                        onChange={e => {
                                            validation.setFieldValue(
                                                `contentCard${cardNumber}Number`,
                                                e.target.value
                                            )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`contentCard${cardNumber}Number`]}
                                        invalid={
                                            validation.touched[`contentCard${cardNumber}Number`] &&
                                                validation.errors[`contentCard${cardNumber}Number`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                    />
                                    {validation.touched[`contentCard${cardNumber}Number`] &&
                                        validation.errors[`contentCard${cardNumber}Number`] && (
                                            <FormFeedback type="invalid">
                                                {validation.errors[`contentCard${cardNumber}Number`]}
                                            </FormFeedback>
                                        )}
                                </div>
                            </li>
                            <li className="list-group-item p-2">
                                <label
                                    htmlFor={`contentCard${cardNumber}Unit`}
                                    className="col-md-12 col-form-label"
                                >
                                    Unit
                                </label>
                                <div className="col-md-12">
                                    <Input
                                        id={`contentCard${cardNumber}Unit`}
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        name={`contentCard${cardNumber}Unit`}
                                        onChange={e => {
                                            validation.setFieldValue(
                                                `contentCard${cardNumber}Unit`,
                                                e.target.value
                                            )
                                        }}
                                        onBlur={validation.handleBlur}
                                        value={validation.values[`contentCard${cardNumber}Unit`]}
                                        invalid={
                                            validation.touched[`contentCard${cardNumber}Unit`] &&
                                                validation.errors[`contentCard${cardNumber}Unit`]
                                                ? true
                                                : false
                                        }
                                        disabled={pageView === "view"}
                                    />
                                    {validation.touched[`contentCard${cardNumber}Unit`] &&
                                        validation.errors[`contentCard${cardNumber}Unit`] && (
                                            <FormFeedback type="invalid">
                                                {validation.errors[`contentCard${cardNumber}Unit`]}
                                            </FormFeedback>
                                        )}
                                </div>
                            </li>
                        </ul>

                    </CardBody>
                </Card>
            </Col>
        </>
    )
}
export default CardPiecePerformance